import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=0ba37d86&scoped=true&"
import script from "./Preview.vue?vue&type=script&lang=ts&"
export * from "./Preview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba37d86",
  null
  
)

export default component.exports